import { render, staticRenderFns } from "./privacyPollcy.vue?vue&type=template&id=7caeacca&scoped=true&"
import script from "./privacyPollcy.vue?vue&type=script&lang=js&"
export * from "./privacyPollcy.vue?vue&type=script&lang=js&"
import style0 from "./privacyPollcy.vue?vue&type=style&index=0&id=7caeacca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caeacca",
  null
  
)

export default component.exports